import { createContext } from 'react';

/**
 * Live lineup (on court / bench / substitutions) shared with the scoreboards'
 * InlinePlayerGrid. Null outside LiveMatch, so the grid keeps its plain behaviour.
 */
const LineupContext = createContext(null);

export default LineupContext;
